import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { SendContractNotificationProps } from 'shared/services/contract-service';

export function useSendContractNotification() {
  const { contractService } = useService();
  const mutation = useMutation<void, Error, SendContractNotificationProps>(request =>
    contractService.sendContractNotification(request)
  );

  return mutation;
}
